<div class="mc-container">
  <div class="mc-close" (click)="close()">&#x2715;</div>

  <div class="mc-logo">
    <img src="assets/images/Logo/const-logo.svg" alt="Construction Pathways" />
  </div>

  <h2 class="mc-title">Media consent</h2>

  <p class="mc-body">
    By clicking <strong>Approve</strong>, you agree that Construction Skills Queensland (CSQ) may use your photo,
    video, audio recording, or name from Construction Pathways events for promotional and
    educational purposes for up to <strong>12 months.</strong>
  </p>

  <p class="mc-body">
    If you click Decline, your image, recording, or name will not be used.
  </p>

  <div class="mc-actions">
    <button class="mc-btn mc-decline" [disabled]="isSubmitting" (click)="respond(false)">
      Decline
    </button>
    <button class="mc-btn mc-approve" [disabled]="isSubmitting" (click)="respond(true)">
      Approve
    </button>
  </div>

  <div class="mc-info">
    <h3 class="mc-info-title">How your information is handled</h3>
    <p class="mc-info-body">
      Construction Skills Queensland (CSQ) may collect and securely store your media and related
      information for reporting, promotional, and required legal purposes.
    </p>
    <p class="mc-info-body">
      CSQ is committed to protecting your privacy and keeping your information secure.
    </p>
    <p class="mc-info-body">
      To read through the full explanation <span class="mc-link-highlight">click on link here</span>
    </p>
  </div>
</div>
